'use client';

import { useEffect, useState } from 'react';

/**
 * The toolbar contents' slide-up entrance is a first-paint nicety. The
 * toolbars remount on some route changes (`/` swaps HomeFloatingChrome for
 * DesktopToolbar/MobileToolbar), which used to replay the animation on every
 * navigation away from the landing page and read as jank. This module-scoped
 * flag survives client-side navigation, so the animation runs on the first
 * full page load only.
 */
let entrancePlayed = false;

const HEADER_ENTRANCE_ANIMATION =
  'bl-fade-in 0.45s cubic-bezier(0.22, 1, 0.36, 1) both';

/** Returns the entrance animation on first full page load, undefined after.
 *  SSR always renders the animation — the flag is only ever set in the
 *  browser (module scope on the server is shared across requests), and the
 *  client's hydration pass agrees because `entrancePlayed` is still false
 *  on a fresh load. */
export function useHeaderEntranceOnce(): string | undefined {
  const [animate] = useState(
    () => typeof window === 'undefined' || !entrancePlayed,
  );

  useEffect(() => {
    entrancePlayed = true;
  }, []);

  return animate ? HEADER_ENTRANCE_ANIMATION : undefined;
}
